import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useVModel } from "@vueuse/core";
import { defineAsyncComponent, onBeforeMount, ref, watch } from "vue";
// Components
import SelectorBase from "./SelectorBase.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SelectorWrapper',
    props: {
        modelValue: {},
        config: {},
        label: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        let CustomSelector = undefined;
        const loadComponent = async () => {
            const customSelector = props.config.customSelectorComponent;
            try {
                if (customSelector) {
                    CustomSelector = defineAsyncComponent(() => Promise.resolve(customSelector));
                }
            }
            catch (_error) {
                return null;
            }
            return null;
        };
        onBeforeMount(() => {
            if (props.config.customSelectorComponent) {
                loadComponent();
            }
        });
        const model = props.modelValue != null ? useVModel(props, "modelValue") : ref(undefined);
        const emit = __emit;
        watch(() => props.modelValue, (newValue) => {
            if (newValue !== model.value) {
                model.value = newValue;
            }
        });
        watch(model, (newValue) => {
            emit("update:modelValue", newValue);
        });
        return (_ctx, _cache) => {
            return (_unref(CustomSelector))
                ? (_openBlock(), _createBlock(_unref(CustomSelector), {
                    key: 0,
                    modelValue: _unref(model),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                    config: props.config,
                    label: props.label
                }, null, 8, ["modelValue", "config", "label"]))
                : (_openBlock(), _createBlock(SelectorBase, {
                    key: 1,
                    modelValue: _unref(model),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                    config: props.config,
                    label: props.label
                }, null, 8, ["modelValue", "config", "label"]));
        };
    }
});
